export default __webpack_public_path__ + "static/media/Karyn.721facb9.png";